module.exports = __webpack_public_path__ + "img/podcast.6e32bb8.jpg";